import React from "react";
import { OverlaySlider } from "@learningblocks/protocol-components";
import { COMPONENT_TYPE } from "@learningblocks/exp-constants/lib/Utilities";
const CLASSNAMES = {
  CORRECT: "correct",
  INCORRECT: "incorrect",
};

export class TypedOption extends React.Component {
  renderFeedback() {
    if (this.props.disabled) {
      return (
        <p
          className={
            this.props.isCorrect ? CLASSNAMES.CORRECT : CLASSNAMES.INCORRECT
          }
        >
          {this.props.feedback}
        </p>
      );
    } else {
      return null;
    }
  }

  selectOption = (event) => {
    event.stopPropagation();
    if (this.props.disabled === false) {
      this.props.selectOption({
        componentID: this.props.componentID,
        optionID: this.props.id,
        checked: !this.props.selected,
      });
    }
  };

  wrapperClass() {
    const classList = [this.props.className, "choice"];
    if (this.props.disabled) {
      if (this.props.isCorrect) classList.push(CLASSNAMES.CORRECT);
      else classList.push(CLASSNAMES.INCORRECT);
    }
    return classList.join(" ");
  }

  getHighlight = () => {
    const { start, end } = this.props.current;
    let size = end - start;
    return [start, size];
  };

  renderComponent() {
    if (COMPONENT_TYPE.SEQUENCE_SLIDER === this.props.type) {
      return (
        <OverlaySlider
          sequence={this.props.sequence}
          disable={this.props.disable}
          highlight={this.getHighlight()}
          highlightClass={this.props.highlightClass}
        />
      );
    } else {
      return <span> NULL component</span>;
    }
  }

  render() {
    return (
      <>
        <div className={this.wrapperClass()} onClick={this.selectOption}>
          <input
            type="radio"
            id={this.props.text}
            value={this.props.id}
            checked={this.props.selected}
            disabled={this.props.disabled}
          />
          {this.renderComponent()}
        </div>
        {this.renderFeedback()}
      </>
    );
  }
}
